module.exports = __webpack_public_path__ + "static/img/IMG_20150612_155351.e634a7e9.jpg";